// Dependencies
import React, { Component } from 'react';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import FormularioContactoModal from '../../subcomponents/FormularioContactoModal';
import IconBlock from '../../subcomponents/IconBlock28';
import banner from '../../assets/img/vector/vps.svg';
import ImageText from '../../subcomponents/ImageText';
import img1 from '../../assets/img/flat/cloudvps1.svg';
import img2 from '../../assets/img/flat/cloudvps2.svg';
import img3 from '../../assets/img/flat/cloudvps3.svg';

// Branding 
import kvm from '../../assets/img/brand/kvm.png'
import debian from '../../assets/img/brand/debian.png'
import ceph from '../../assets/img/brand/ceph.png'

class CloudVps extends Component {

    constructor(props) {
        super(props);
        this.state = { modalAsunto: 'Contacto' };
    }
    
    componentDidMount() {
        document.title = 'Cloud VPS - Insacom';
    }

    render() {

        let iconBlocks = [
            {id: 1, title: 'Object Storage', description: 'Storage distribuido basado en Ceph', img: img1 },
            {id: 2, title: 'Full SSD', description: 'Todos Nodos de Computo y de Storage cuentan sólo con discos SSD Enterprise', img: img2 },
            {id: 3, title: 'Cluster Optimizado', description: 'Nuestro Cluster está optimizado para siempre tener un rendimiento excepcional', img: img3 }
        ];

        const vpsData = [
            {
                title: 'Plus',
                price: '1 UF',
                paymentType: 'Mes + IVA',
                info: [
                    <li className="g-mb-15">2GB Memoria Ram</li>,
                    <li className="g-mb-15">Tráfico Ilimitado</li>,
                    <li className="g-mb-15">50GB Disco Duro</li>,
                    <li className="g-mb-15">IP Pública Dedicada</li>,
                    <li className="g-mb-15">Acceso Root</li>,
                    <li className="g-mb-15">CentOS - Debian - Ubuntu</li>,
                    <li className="g-mb-15">Firewall Físico</li>
                ],
                buttonText: 'Contratar'
            },
            {
                title: 'Premium',
                price: '2 UF',
                paymentType: 'Mes + IVA',
                info: [
                    <li className="g-mb-15">4GB Memoria Ram</li>,
                    <li className="g-mb-15">Tráfico Ilimitado</li>,
                    <li className="g-mb-15">100GB Disco Duro</li>,
                    <li className="g-mb-15">IP Pública Dedicada</li>,
                    <li className="g-mb-15">Acceso Root</li>,
                    <li className="g-mb-15">CentOS - Debian - Ubuntu</li>,
                    <li className="g-mb-15">Firewall Físico</li>
                ],
                buttonText: 'Contratar'
            },
            {
                title: 'Ultra',
                price: '3 UF',
                paymentType: 'Mes + IVA',
                info: [
                    <li className="g-mb-15">8GB Memoria Ram</li>,
                    <li className="g-mb-15">Tráfico Ilimitado</li>,
                    <li className="g-mb-15">150GB Disco Duro</li>,
                    <li className="g-mb-15">IP Pública Dedicada</li>,
                    <li className="g-mb-15">Acceso Root</li>,
                    <li className="g-mb-15">CentOS - Debian - Ubuntu</li>,
                    <li className="g-mb-15">Firewall Físico</li>
                ],
                buttonText: 'Contratar'
            },
        ]

        const descripcion = "Tu mejor elección para proyectos en crecimiento. La libertad de un servidor independiente, con el mejor rendimiento y disponibilidad.";

        return (
            <Section no-contact>
                <SectionContainer grey paddingBottom={'0px'} no-padding>
                    <ImageText 
                        image={banner} 
                        title="Cloud VPS" 
                        description={descripcion}>
                            <div className="d-flex justify-content-around flex-wrap">
                                <div className="align-self-center">
                                    <img src={kvm} alt="KVM" style={{height: '40px', marginRight: '20px'}}></img>
                                </div>
                                <div className="align-self-center">
                                    <img src={debian} alt="Debian" style={{height: '60px'}}></img>
                                </div>
                                <div className="align-self-center">
                                    <img src={ceph} alt="CEPH" style={{height: '80px'}}></img>
                                </div>
                            </div>
                    </ImageText>
                </SectionContainer>
                <SectionContainer >
                    <IconBlock content={iconBlocks}></IconBlock>
                </SectionContainer>
                <SectionContainer grey>
                        <div className="text-center g-mb-50">
                            <h2 className="h1 g-color-black g-font-weight-600">VPS</h2>
                            <p className="lead">VPS robustos de alto rendimiento con el mejor soporte.</p>
                        </div>
                        <div className="row">
                            {vpsData && vpsData.map((vps, key) =>
                                <div key={key} className="col-md-4">
                                    <article className="text-center g-rounded-10 g-overflow-hidden g-px-30 g-py-40">
                                        <h3 className="h5 text-uppercase g-font-weight-700 g-letter-spacing-3 g-mb-30">{vps.title}</h3>

                                        <div className="m-auto g-flex-middle g-width-100 g-height-100 g-rounded-50x g-brd-around g-brd-2 g-brd-primary g-color-primary">
                                            <span className="g-font-size-22 g-font-weight-600 g-flex-middle-item">{vps.price}</span>
                                        </div>
                                        <div className="g-color-primary g-my-10">
                                            {vps.paymentType}
                                        </div>

                                        <ul className="list-unstyled g-mb-40">
                                            {vps.info && vps.info.map((vpsInfo, key) =>
                                                <div key={key}>{vpsInfo}</div>
                                            )}
                                        </ul>
                                        <button 
                                            data-modal-target="#contacto-modal"
                                            onClick={() => {
                                                this.setState({modalAsunto: 'VPS Plan ' + vps.title}) 
                                            }}
                                            className="btn text-uppercase u-btn-primary g-rounded-50 g-font-size-12 g-font-weight-700 g-pa-15-30">{vps.buttonText}</button>
                                    </article>
                                </div>
                            )}

                        </div>
                </SectionContainer>
                <FormularioContactoModal asunto={this.state.modalAsunto} />
            </Section>
        );
    }
}

export default CloudVps;


// WEBPACK FOOTER //
// ./src/sections/datacenter/CloudVps.js